export default __webpack_public_path__ + "static/media/portfolioImg_2.eaa240bb.webp";